import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.refreshLabel()
  }

  toggle() {
    const current = this.currentTheme()
    const next    = current === "light" ? "dark" : "light"
    document.documentElement.dataset.theme = next
    this.refreshLabel()
    this.persist(next)
  }

  currentTheme() {
    const explicit = document.documentElement.dataset.theme
    if (explicit === "dark" || explicit === "light") return explicit
    return matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark"
  }

  refreshLabel() {
    if (!this.hasButtonTarget) return
    const current = this.currentTheme()
    this.buttonTarget.textContent = current === "light" ? "Dark" : "Light"
  }

  persist(value) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch("/theme", {
      method:  "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token || "",
        "Accept":       "application/json",
      },
      body: JSON.stringify({ theme: value }),
    }).catch(() => { /* fire-and-forget */ })
  }
}
